import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Form from "./details components/Form";
import { useComponent } from "../../hooks";
import { Loader } from "../../components";
import {
  objectFromResponseData,
  resourceObject,
} from "./details components/resourceObject";

export default function ResourceDetails({ pageID }) {
  const { resourceID } = useParams();
  const { loader, axios, pagePermissions } = useComponent({ pageID });
  const [resource, setResource] = useState([]);
  const [editState, setEditState] = useState(true);
  const [formData, setFormData] = useState(resourceObject);

  const { ID } = useSelector((state) => state.memberDetails.activeBot);

  useEffect(() => {
    loader.start(1);

    if (!!resourceID) {
      setEditState(false);
    }

    // axios({
    //   url: "/resources",
    // }).then((response) => {
    //   if (response.status) {
    //     setResource(response.data);
    //   }
    //   loader.apiComplete();
    // });

    if (!!resourceID) {
      axios({
        url: "/resources/" + ID + "?resource_id=" + resourceID,
      }).then((response) => {
        if (response.status) {
          setFormData(objectFromResponseData(response.data));
          loader.apiComplete();
        }
      });
    } else {
      loader.apiComplete();
    }
  }, [axios, loader, ID, resourceID]);

  return (
    <Loader>
      <Form
        pagePermissions={pagePermissions}
        resource={resource}
        formData={formData}
        editState={editState}
        setEditState={setEditState}
      />
    </Loader>
  );
}
